<template>
  <div class="flex flex-col bg-white rounded-lg">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-blocksm:px-6 lg:px-8">
        <div
          class="overflow-y-auto border-b border-gray-200 sm:rounded-lg scrollbar-w-2 scrollbar-track-gray-lighter scrollbar-thumb-rounded scrollbar-thumb-gray h-96 max-h-full"
        >
          <table class="min-w-full divide-y divide-gray-200 table-collapse">
            <thead>
              <tr>
                <th
                  class="z-5 sticky top-0 px-6 px-4 bg-gray-50 text-left text-xs leading-4 font-medium bg-gray-50 text-gray-600 uppercase"
                >
                  {{ $t('message.wms.pickingtable.codigo') }}
                </th>
                <th
                  class="z-5 sticky top-0 px-6 py-4 bg-gray-50 text-left text-xs leading-4 font-medium bg-gray-50 text-gray-600 uppercase"
                >
                  {{ $t('message.wms.pickingtable.creacion') }}
                </th>
                <th
                  class="z-5 sticky top-0 px-6 py-4 bg-gray-50 text-left text-xs leading-4 font-medium bg-gray-50 text-gray-600 uppercase"
                >
                  {{ $t('message.wms.pickingtable.items') }}
                </th>
                <th
                  class="z-5 sticky top-0 px-6 py-4 bg-gray-50 text-left text-xs leading-4 font-medium bg-gray-50 text-gray-600 uppercase"
                >
                  {{ $t('message.wms.pickingtable.estado') }}
                </th>
                <th class="z-5 sticky top-0 px-6 py-3 bg-gray-50">
                  <span class="sr-only">{{
                    $t('message.wms.pickingtable.acciones')
                  }}</span>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr
                v-for="item in items"
                v-on:click="$parent.selectOrder(item.id)"
                :key="item.id"
              >
                <td
                  class="px-6 py-3 whitespace-no-wrap text-xs leading-5 text-gray-900"
                >
                  {{ item.code }}
                </td>
                <td
                  class="px-6 py-3 whitespace-no-wrap text-xs leading-5 text-gray-700"
                >
                  {{ item.date_i }}
                </td>
                <td
                  class="px-6 py-3 whitespace-no-wrap text-xs leading-5 text-gray-700"
                >
                  {{ item.storageboxes.length }}
                </td>
                <td
                  class="px-6 py-3 whitespace-no-wrap text-xs leading-5 text-gray-700"
                >
                  {{ item.status }}
                </td>
                <td
                  class="px-6 whitespace-nowrap text-right text-sm font-medium"
                >
                  <div class="py-2 relative inline-block text-left">
                    <button
                      v-on:click="$emit('additem', item.id)"
                      class="rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
                      id="options-menu"
                      aria-haspopup="true"
                      aria-expanded="true"
                    >
                      <span class="sr-only">
                        {{ $t('message.wms.pickingtable.nuevoitem') }}
                      </span>
                      <!-- Heroicon name: plus-circle -->
                      <svg
                        class="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'picking-table',
  props: {
    searchinput: String,
    filtertype: String
  },
  created() {
    this.fetchItems();
    // catch event from Picking Menu to fetch new orders
    this.$root.$on('new-picking-order', this.fetchItems);
  },
  data() {
    return {
      items: []
    };
  },
  watch: {
    searchinput() {
      this.fetchItems();
    },
    filtertype() {
      this.fetchItems();
    }
  },
  methods: {
    async fetchItems() {
      console.log(this.searchinput);
      const response = await this.$http.get(
        `wms/pickingorders?searchinput=${this.searchinput}`
      );
      this.items = response.data.pickingorders;
      console.log(this.items);
    }
  }
};
</script>
